import * as React from 'react';
import {
  BreadcrumbLargeText,
  BreadcrumbLink,
  BreadcrumbText,
  SpaceBetween,
} from './ChartOptions.styles';

export const Breadcrumbs = ({
  breadcrumbs,
  onClick,
}: {
  breadcrumbs: string[];
  onClick: (id: number) => void;
}) => {
  if (breadcrumbs.length === 1) {
    return <BreadcrumbLargeText>{breadcrumbs[0]}</BreadcrumbLargeText>;
  }
  if (breadcrumbs.length === 2) {
    return (
      <>
        <BreadcrumbLink role="button" onClick={() => onClick(0)}>
          {breadcrumbs[0]}
        </BreadcrumbLink>
        <SpaceBetween>/</SpaceBetween>
        <BreadcrumbText>{breadcrumbs[1]}</BreadcrumbText>
      </>
    );
  }
  if (breadcrumbs.length === 3) {
    return (
      <>
        <BreadcrumbLink role="button" onClick={() => onClick(0)}>
          {breadcrumbs[0]}
        </BreadcrumbLink>
        <SpaceBetween>/</SpaceBetween>
        <BreadcrumbLink role="button" onClick={() => onClick(1)}>
          {breadcrumbs[1]}
        </BreadcrumbLink>
        <SpaceBetween>/</SpaceBetween>
        <BreadcrumbText>{breadcrumbs[2]}</BreadcrumbText>
      </>
    );
  }
  return null;
};
